import React from 'react'
import { Breadcrumb, Statistic, Card, Col, Row } from 'antd';


export const WeekStatics=({item})=> {
    return (
         <Card 
        style={{ background:item.background, fontSize: 25, color: 'white' }}
        title={<span>{item.Icon} {item.title}</span>} bordered={true}>
        <Statistic value={item.value} />
    </Card>  
    )
}

export default WeekStatics
